<template>
  <view class="u-page">
    <view class="title">{{detail.title}}</view>
    <view class="time">{{detail.createTime}}</view>
    <u-parse :content="detail.content"></u-parse>
  </view>
</template>

<script>
import {getNotice} from "@/common/api";
export default {
  name: "index",
  data(){
    return{
      id:0,
      detail:{}
    }
  },
  onLoad(option){
    uni.setNavigationBarTitle({ title: '园区公告详情'})
    let _this = this;
    _this.id = option.id;
    _this.getDetail();

  },
  methods: {
    getDetail(){
      getNotice(this.id).then(res=>{
        this.detail = res
      })
    },

  },
}
</script>

<style scoped lang="scss">
.u-page{
  padding: 20px;
  background: white;
  .title{text-align: center;
    color: #000;
    line-height: 28px;
    font-weight: bold;
    font-size: 16px;
  }
  .time{
    text-align: center;
    line-height: 24px;
    color: #999;
    margin-bottom: 20px;
    font-size: 14px;
  }
}
</style>
